import classNames from "classnames";
import React from "react";
import { t } from "ttag";

import { useAppSelector } from "../../reducers";
import { Step } from "../constants";

interface IProps {
    onEdit?: (event?: React.MouseEvent<HTMLElement>) => void;
}

export const ShippingAddressSummary = (props: IProps): React.ReactNode => {
    const user = useAppSelector((state) => state.common.user);
    const form = useAppSelector((state) => state.checkout.form);
    const showSummary = useAppSelector(
        (state) => state.checkout.form.current_step > Step.SHIPPING_ADDRESS,
    );

    const summaryClasses = classNames({
        "checkout-step__summary": true,
        "checkout-step__summary--collapsed": !showSummary,
    });

    return (
        <div className={summaryClasses}>
            <h3 className="checkout-step__label">{t`Ship to:`}</h3>
            <div className="checkout-step__summary-address">
                {/* TODO(i18n): Hard-coded address format assumes US/Western name order and address structure. Consider localizing address formatting for international markets. */}
                {form.shipping_first_name} {form.shipping_last_name}
                <br />
                {form.shipping_line1}
                <br />
                {form.shipping_line2 ? <div>{form.shipping_line2}</div> : null}
                {/* TODO(i18n): Hard-coded comma separator and address format (city, state zip) is US-specific. Different locales have different address formats. */}
                {form.shipping_line4}, {form.shipping_state}{" "}
                {form.shipping_postcode}
                <br />
                {form.shipping_phone_number}
                <br />
                {user && user.email && !user.is_csr
                    ? user.email
                    : form.guest_email}
                <br />
            </div>
            {props.onEdit && (
                <a
                    className="checkout-step__back"
                    href="#"
                    onClick={props.onEdit}
                >
                    {t`Edit`}
                </a>
            )}
        </div>
    );
};
